/* Wumi — scripts partagés des sections custom */
(function () {
  'use strict';

  /* ---------- Accordéons .wumi-faq : ouverture / fermeture animées ----------
     Délégation sur le document : fonctionne pour toutes les sections (FAQ, bloc achat)
     et pour les sections rechargées par l'éditeur de thème. */
  var DURATION = 320;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function animateFaq(details) {
    var summary = details.querySelector('summary');
    var answer = details.querySelector('.wumi-faq__answer');
    if (!summary || !answer || typeof details.animate !== 'function' || reduceMotion.matches) {
      details.open = !details.open;
      return;
    }

    if (details._wumiAnim) {
      details._wumiAnim.cancel();
    }

    var startHeight = details.offsetHeight;
    var isOpening = !details.open;
    var endHeight;

    details.style.overflow = 'hidden';

    if (isOpening) {
      details.open = true;
      endHeight = summary.offsetHeight + answer.offsetHeight;
      answer.style.opacity = '0';
    } else {
      endHeight = summary.offsetHeight;
    }

    details.style.height = startHeight + 'px';

    var anim = details.animate(
      { height: [startHeight + 'px', endHeight + 'px'] },
      { duration: DURATION, easing: EASING }
    );
    details._wumiAnim = anim;

    if (isOpening) {
      answer.animate({ opacity: [0, 1] }, { duration: DURATION, delay: DURATION / 3, easing: 'ease-out' });
    } else {
      answer.animate({ opacity: [1, 0] }, { duration: DURATION / 2, easing: 'ease-in' });
    }

    anim.onfinish = function () {
      if (!isOpening) details.open = false;
      details.style.height = '';
      details.style.overflow = '';
      answer.style.opacity = '';
      details._wumiAnim = null;
    };
    anim.oncancel = function () {
      details.style.height = '';
      details.style.overflow = '';
      answer.style.opacity = '';
      details._wumiAnim = null;
    };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('.wumi-faq > summary');
    if (!summary) return;
    var details = summary.parentElement;
    event.preventDefault();
    animateFaq(details);
  });

  /* ---------- Hauteur du header en direct : style="--header-height: …px" sur <html> ----------
     Recalculée à chaque changement de taille (rotation, redimensionnement, passage sur deux lignes en mobile),
     réutilisable partout en CSS : calc(var(--header-height) + …). */
  var root = document.documentElement;

  function measureHeader() {
    var group = document.getElementById('header-group');
    var height = group ? Math.round(group.getBoundingClientRect().height) : 0;
    var sticky = !!(group && group.querySelector('.wumi-header--sticky'));
    root.style.setProperty('--header-height', height + 'px');
    root.style.setProperty('--header-sticky-height', (sticky ? height : 0) + 'px');
  }

  function initHeaderMeasure() {
    measureHeader();
    var group = document.getElementById('header-group');
    if (group && 'ResizeObserver' in window) {
      new ResizeObserver(measureHeader).observe(group);
    }
    window.addEventListener('resize', measureHeader);
    window.addEventListener('orientationchange', measureHeader);
    window.addEventListener('load', measureHeader);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureHeader);
    document.addEventListener('shopify:section:load', measureHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderMeasure);
  } else {
    initHeaderMeasure();
  }

  /* ---------- Retour en haut : visible une fois le hero dépassé ---------- */
  function initBackToTop() {
    var btn = document.querySelector('[data-wumi-back-to-top]');
    if (!btn) return;
    var hero = document.querySelector('.wumi-hero');
    var pageWrapper = document.querySelector('.page-wrapper');
    var visible = false;

    /* Sur desktop (≥ 990px), Horizon fait défiler `.page-wrapper` (html/body en overflow hidden) et non la fenêtre :
       on écoute donc les deux et on lit la position du conteneur qui défile réellement. */
    function scroller() {
      if (pageWrapper) {
        var oy = getComputedStyle(pageWrapper).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && pageWrapper.scrollHeight > pageWrapper.clientHeight) return pageWrapper;
      }
      return null;
    }

    function scrollTop() {
      var el = scroller();
      return el ? el.scrollTop : window.pageYOffset;
    }

    function setVisible(state) {
      if (state === visible) return;
      visible = state;
      if (state) {
        btn.hidden = false;
        /* Deux frames : le navigateur applique d'abord l'état initial (opacité 0, décalé vers le bas), puis anime */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { btn.classList.add('is-visible'); });
        });
      } else {
        btn.classList.remove('is-visible');
        setTimeout(function () { if (!visible) btn.hidden = true; }, 380);
      }
    }

    function threshold() {
      if (hero) return hero.getBoundingClientRect().bottom + scrollTop();
      return window.innerHeight;
    }

    function update() {
      setVisible(scrollTop() > threshold() - 1);
    }

    window.addEventListener('scroll', update, { passive: true });
    if (pageWrapper) pageWrapper.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    btn.addEventListener('click', function () {
      var behavior = reduceMotion.matches ? 'auto' : 'smooth';
      var el = scroller();
      if (el) el.scrollTo({ top: 0, behavior: behavior });
      window.scrollTo({ top: 0, behavior: behavior });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackToTop);
  } else {
    initBackToTop();
  }

  /* ---------- Ancre #shop sur mobile : atterrir sous les photos (colonne texte). Desktop : ancre native en haut de section ---------- */
  var shopMobileQuery = window.matchMedia('(max-width: 749px)');

  function stickyHeaderHeight() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')) || 0;
  }

  function scrollToShopMeta(smooth) {
    if (!shopMobileQuery.matches) return false;
    var meta = document.querySelector('#shop [data-wumi-shop-meta]');
    if (!meta) return false;
    var top = meta.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() + 1;
    window.scrollTo({ top: top, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!shopMobileQuery.matches) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1 || href.slice(hashIndex) !== '#shop') return;
    var path = href.slice(0, hashIndex);
    if (path && path !== window.location.pathname && path + '/' !== window.location.pathname && path !== window.location.pathname + '/') return;
    if (scrollToShopMeta(true)) {
      event.preventDefault();
      if (history.replaceState) history.replaceState(null, '', '#shop');
    }
  });

  if (window.location.hash === '#shop') {
    window.addEventListener('load', function () {
      setTimeout(function () { scrollToShopMeta(false); }, 80);
    });
  }

  /* ---------- Popup de langue selon le pays (VPN / visiteur étranger). Choix mémorisé N jours dans un cookie ---------- */
  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function writeCookie(name, value, days) {
    var maxAge = Math.max(1, Math.round((days || 30) * 86400));
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; samesite=lax';
  }

  (function languagePopup() {
    var cfg = window.WumiGeo;
    var popup = document.querySelector('[data-wumi-lang-popup]');
    var cookieName = (cfg && cfg.cookieName) || 'wumi_lang_choice';
    var cookieDays = (cfg && cfg.cookieDays) || 30;

    /* Un clic sur FR / EN (header, footer, page mot de passe) vaut choix explicite */
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.wumi-lang a[hreflang]');
      if (link) writeCookie(cookieName, link.getAttribute('hreflang'), cookieDays);
    });

    if (!cfg || !popup || cfg.designMode || !cfg.available || cfg.available.length < 2) return;
    if (readCookie(cookieName)) return;
    if (!cfg.country) return;

    var french = (cfg.frenchCountries || []).map(function (c) { return String(c).trim().toUpperCase(); });
    var wanted = french.indexOf(String(cfg.country).toUpperCase()) !== -1 ? cfg.primary : 'en';
    if (cfg.available.indexOf(wanted) === -1 || wanted === cfg.current) return;

    var variant = popup.querySelector('[data-wumi-lang-variant="' + wanted + '"]');
    if (!variant) return;
    variant.hidden = false;

    function close() {
      popup.classList.remove('is-visible');
      document.documentElement.classList.remove('wumi-modal-open');
      setTimeout(function () { popup.hidden = true; }, 250);
    }

    popup.querySelectorAll('[data-wumi-lang-popup-stay]').forEach(function (el) {
      el.addEventListener('click', function () {
        writeCookie(cookieName, cfg.current, cookieDays);
        close();
      });
    });
    popup.querySelectorAll('[data-wumi-lang-popup-switch]').forEach(function (el) {
      el.addEventListener('click', function () {
        writeCookie(cookieName, el.getAttribute('data-wumi-lang-popup-switch'), cookieDays);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) {
        writeCookie(cookieName, cfg.current, cookieDays);
        close();
      }
    });

    setTimeout(function () {
      popup.hidden = false;
      document.documentElement.classList.add('wumi-modal-open');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { popup.classList.add('is-visible'); });
      });
    }, 600);
  })();

  /* ---------- Ancre #shop sur mobile : atterrir sous les photos (colonne texte). Desktop : ancre native en haut de section ---------- */
  var shopMobileQuery = window.matchMedia('(max-width: 749px)');

  function stickyHeaderHeight() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')) || 0;
  }

  function scrollToShopMeta(smooth) {
    if (!shopMobileQuery.matches) return false;
    var meta = document.querySelector('#shop [data-wumi-shop-meta]');
    if (!meta) return false;
    var top = meta.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() + 1;
    window.scrollTo({ top: top, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!shopMobileQuery.matches) return;
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1 || href.slice(hashIndex) !== '#shop') return;
    var path = href.slice(0, hashIndex);
    if (path && path !== window.location.pathname && path + '/' !== window.location.pathname && path !== window.location.pathname + '/') return;
    if (scrollToShopMeta(true)) {
      event.preventDefault();
      if (history.replaceState) history.replaceState(null, '', '#shop');
    }
  });

  if (window.location.hash === '#shop') {
    window.addEventListener('load', function () {
      setTimeout(function () { scrollToShopMeta(false); }, 80);
    });
  }

  /* ---------- Langue selon le pays (VPN / visiteur étranger) : anglais hors pays francophones, sauf choix explicite ---------- */
  var LANG_CHOICE_COOKIE = 'wumi_lang_choice';

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function writeCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=31536000; samesite=lax';
  }

  /* Un clic sur FR / EN est un choix explicite, mémorisé un an */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.wumi-lang a[hreflang]');
    if (link) writeCookie(LANG_CHOICE_COOKIE, link.getAttribute('hreflang'));
  });

  (function geoLanguage() {
    var cfg = window.WumiGeo;
    if (!cfg || cfg.designMode || !cfg.available || cfg.available.length < 2) return;
    var choice = readCookie(LANG_CHOICE_COOKIE);
    if (choice) return;
    if (!cfg.country) return;
    var french = (cfg.frenchCountries || []).map(function (c) { return String(c).trim().toUpperCase(); });
    var wanted = french.indexOf(String(cfg.country).toUpperCase()) !== -1 ? cfg.primary : 'en';
    if (cfg.available.indexOf(wanted) === -1 || wanted === cfg.current) {
      writeCookie(LANG_CHOICE_COOKIE, cfg.current);
      return;
    }
    var path = window.location.pathname;
    var currentPrefix = cfg.current === cfg.primary ? '' : '/' + cfg.current;
    if (currentPrefix && path.indexOf(currentPrefix) === 0) path = path.slice(currentPrefix.length) || '/';
    var targetPrefix = wanted === cfg.primary ? '' : '/' + wanted;
    writeCookie(LANG_CHOICE_COOKIE, wanted);
    window.location.replace(targetPrefix + path + window.location.search + window.location.hash);
  })();
})();
